import React from "react";
import {Box, Button, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowRight01Icon, Wrench01Icon} from "@hugeicons/core-free-icons";

// Shown for registry project pages that have not been rebuilt yet; links to the same page in the flow layout
export const RegistryPagePlaceholder = ({label, path, subProject}) => {
  const legacyUrl = subProject?.flowUid
    ? `/project/${subProject.flowUid}${path ? `/${path}` : ""}`
    : null;

  return (
    <Stack alignItems={"center"} justifyContent={"center"} sx={{flex: 1, p: 3}}>
      <Stack alignItems={"center"} gap={1.5} sx={{maxWidth: 420, textAlign: "center"}}>
        <Box sx={{
          display: "flex", alignItems: "center", justifyContent: "center",
          width: 48, height: 48, borderRadius: 3,
          bgcolor: "rgba(132, 145, 247, 0.12)", color: "primary.main"
        }}>
          <HugeiconsIcon icon={Wrench01Icon} size={22}/>
        </Box>
        <Typography variant={"h5"} fontWeight={600}>{label}</Typography>
        <Typography color={"text.secondary"}>
          This page is being rebuilt for {subProject?.languageName || "this language"}.
        </Typography>
        {legacyUrl && (
          <Button
            component={Link}
            to={legacyUrl}
            variant={"ghost"}
            endIcon={<HugeiconsIcon icon={ArrowRight01Icon} size={16}/>}
          >
            Open in the current flow
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
